import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealApiResponse } from "@zeal/common";
import {
  TCreateLaborPosterRequestSchema,
  TCreateLaborPosterResponseSchema,
} from "./createLaborPoster.schema";

export const createLaborPoster = (axios: IAxiosInstance) => {
  return async (
    data: TCreateLaborPosterRequestSchema
  ): Promise<ZealApiResponse<TCreateLaborPosterResponseSchema>> => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, String(value));
        }
      }
    });
    const response = await axios.noRetry.post<
      ZealApiResponse<TCreateLaborPosterResponseSchema>
    >("/labor-posters", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  };
};
